export const RequiredField = () => {
  return <span className="text-red-500 text-[12px]">Campo Requerido</span>;
};